module.exports = __webpack_public_path__ + "img/blank.5839a443.svg";